var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83317 0.833252C4.08427 0.833252 2.6665 2.25102 2.6665 3.99992C2.6665 5.74882 4.08427 7.16659 5.83317 7.16659C7.58207 7.16659 8.99984 5.74882 8.99984 3.99992C8.99984 2.25102 7.58207 0.833252 5.83317 0.833252ZM3.6665 3.99992C3.6665 2.8033 4.63655 1.83325 5.83317 1.83325C7.02979 1.83325 7.99984 2.8033 7.99984 3.99992C7.99984 5.19654 7.02979 6.16659 5.83317 6.16659C4.63655 6.16659 3.6665 5.19654 3.6665 3.99992Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83317 8.16659C2.08427 8.16659 0.666504 9.58435 0.666504 11.3333C0.666504 13.0822 2.08427 14.4999 3.83317 14.4999H7.83317C8.10931 14.4999 8.33317 14.2761 8.33317 13.9999C8.33317 13.7238 8.10931 13.4999 7.83317 13.4999H3.83317C2.63655 13.4999 1.6665 12.5299 1.6665 11.3333C1.6665 10.1366 2.63655 9.16659 3.83317 9.16659H7.83317C8.10931 9.16659 8.33317 8.94273 8.33317 8.66659C8.33317 8.39044 8.10931 8.16659 7.83317 8.16659H3.83317Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 9.33325C10.9998 9.05711 10.776 8.83325 10.4998 8.83325C10.2237 8.83325 9.99984 9.05711 9.99984 9.33325V10.8333H8.49984C8.22369 10.8333 7.99984 11.0571 7.99984 11.3333C7.99984 11.6094 8.22369 11.8333 8.49984 11.8333H9.99984V13.3333C9.99984 13.6094 10.2237 13.8333 10.4998 13.8333C10.776 13.8333 10.9998 13.6094 10.9998 13.3333V11.8333H12.4998C12.776 11.8333 12.9998 11.6094 12.9998 11.3333C12.9998 11.0571 12.776 10.8333 12.4998 10.8333H10.9998V9.33325Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus);
export default __webpack_public_path__ + "static/media/user-plus.21829c16e15b2270614195bdbbefd091.svg";
export { ForwardRef as ReactComponent };